import { FC, useState } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logo from "../../../../images/EVENT TO BEE-17.png";
interface FactureDownloaderProps {
  reservation: any;
}

const FactureDownloader: FC<FactureDownloaderProps> = ({ reservation }) => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadFacture = () => {
    setIsLoading(true);

    const doc = new jsPDF();
    autoTable(doc, {});

    // Colors defined as tuples
    const primaryColor: [number, number, number] = [70, 99, 172]; // #4663AC
    const textColor: [number, number, number] = [50, 50, 50];
    const white: [number, number, number] = [255, 255, 255];

    // Fonts
    doc.setFont("helvetica", "bold");

    // Header
    doc.setFillColor(...white);
    doc.rect(0, 0, 210, 40, "F");
    doc.setTextColor(...textColor);
    doc.setFontSize(22);
    //doc.text("REÇU", 195, 20, { align: "right" });
    // Logo (Placeholder - replace with actual image path)
    const logoUrl = logo; // Fallback
    try {
      doc.addImage(logoUrl, "PNG", 10, 1, 40, 40);
    } catch (e) {
      console.warn("Logo image could not be loaded:", e);
    }

    // Client and Receipt Details
    doc.setTextColor(...textColor);
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Facture Loueur:", 15, 50);
    doc.text("Code de réservation:", 15, 60);
    doc.setFont("helvetica", "normal");
    doc.text(reservation.invoice_rental_code || "N/A", 43, 50);
    doc.setFont("helvetica", "normal");
    doc.text(reservation.reference, 51, 60);

    doc.setFont("helvetica", "bold");
    doc.text("NOM", 15, 70);
    doc.setFont("helvetica", "normal");
    doc.text(`${reservation.Client?.name || "N/A"} ${reservation.Client?.lastName || ""}`.toUpperCase(), 15, 75);

    doc.setFont("helvetica", "bold");
    doc.text("Adresse", 15, 85);
    doc.setFont("helvetica", "normal");
    doc.text(
      `Adresse du logement: ${reservation.Location?.city || "N/A"} , ${reservation.Location?.address || "N/A"}`,
      15,
      90
    );

    // Reservation Details
    doc.setFont("helvetica", "bold");
    doc.text("Date de l'événement", 15, 100);
    doc.setFont("helvetica", "normal");
    doc.text(
      `${reservation.selectedDate ? new Date(reservation.selectedDate).toLocaleDateString() : "N/A"}`,
      15,
      106
    );
    doc.setFont("helvetica", "bold");
    doc.text("Espace reservé", 15, 115);
    doc.setFont("helvetica", "normal");
    doc.text(reservation.Location?.title || "N/A", 15, 120);

    doc.setFont("helvetica", "bold");
    doc.text("Frais de service EventToBee pour l’utilisation de la plate-forme en ligne", 15, 130);

    // Line Items Table
    const tableData = [];

    // Discount Row

    const serviceTTC = parseFloat(reservation?.service || "0");
    const serviceHT = serviceTTC / 1.2;
    const serviceTVA = serviceTTC - serviceHT;

    tableData.push([`${serviceHT.toFixed(2)} €`, `${serviceTVA.toFixed(2)} €`, `${serviceTTC.toFixed(2)} €`]);

    autoTable(doc, {
      startY: 135,
      head: [["Frais de service", "TVA (20%)", "Total des frais de service"]],
      body: tableData,
      theme: "grid",
      headStyles: {
        fillColor: primaryColor,
        textColor: white,
        fontSize: 10,
        halign: "center",
      },
      styles: {
        fontSize: 9,
        cellPadding: 4,
        textColor: textColor,
      },
      columnStyles: {
        0: { halign: "center" },
        1: { halign: "center" },
        2: { halign: "center" },
      },
    });

    doc.setFont("helvetica", "normal");
    doc.text(
      "* EventToBee applique des frais de service sur le montant de la réservation pour l'utilisation de sa plateforme en ligne.",
      15,
      170
    );
    doc.setFont("helvetica", "normal");
    doc.text(
      "La TVA, calculée sur le total des frais de service du loueur, est facturée au moment du paiement",
      15,
      175
    );

    // Footer
    const footerY = 270;
    doc.setFillColor(...primaryColor);
    doc.rect(0, footerY, 210, 30, "F");
    doc.setFontSize(8);
    doc.setTextColor(...white);
    doc.setFont("helvetica", "normal");
    doc.text("EVENTTOBEE, 7 rue de l’industrie 92400 Courbevoie", 20, footerY + 10);
    const linkText = "www.eventtobee.com";
    doc.text(linkText, 20, footerY + 18);
    // Add clickable link without showing URL
    doc.link(20, footerY + 15, 60, 6, { url: "https://eventtobee.com" });

    // Save PDF
    doc.save(`Facture_${reservation.reference}.pdf`);

    setIsLoading(false);
  };

  return (
    <ButtonPrimary
      loading={isLoading}
      onClick={downloadFacture}
      disabled={isLoading}
      className="transition-transform duration-300 transform sm:w-auto hover:scale-105 btn-primary-gradient"
    >
      <span>Télécharger</span>
    </ButtonPrimary>
  );
};

export default FactureDownloader;
